import { Injectable } from '@angular/core';
import { StudentService } from '../../shared-components/student/student.service';
import { Student } from '../../shared-components/student/student.model';
import { YearService } from '../../shared-components/year/year.service';
import { Year } from '../../shared-components/year/year.model';
import { UserService } from '../../shared-components/user/user.service';
import { StudentField, StudentFieldsLookup } from './student-field.model';
import { HttpClient } from '@angular/common/http';
import { System } from '../../shared-components/System';
import { Observable } from 'rxjs';

@Injectable()
export class StudentFieldService {
  student360Year: Year;
  selectedStudent: Student;

  constructor(
    private studentService: StudentService,
    private yearService: YearService,
    private userService: UserService,
    private http: HttpClient

  ) { }

  getStudentFieldsByStudentId(): Observable<StudentField[]> {
    // POST: returns the student Fileds for a student
    const queryString = '?studentId=' + this.studentService.selectedStudent.Id +
      '&yearId=' + this.yearService.student360Year.Id +
      '&schoolId=' + this.yearService.student360Year.SchoolID;
    return this.http.get<StudentField[]>(System.apiURL.Student + 'GetStudentFieldsByStudentId' + queryString);
  }

  getStudentFieldOptions(studentFields: Array<string>): Observable<StudentFieldsLookup[]> {
    return this.http.post<StudentFieldsLookup[]>(System.apiURL.Student + 'GetStudentFieldsLookup', studentFields);
  }

  validateStudentFieldsData(yearId: number, studentId: number, fields = []) {
    let queryString = '';
    queryString += '?yearId=' + yearId +
      '&studentId=' + studentId;
    return this.http.post<StudentField[]>(System.apiURL.Student + 'ValidateStudentFieldsData' + queryString, fields);
  }

  saveStudentFieldsData(yearId: number, studentId: number, fields = []) {
    let queryString = '';
    queryString += '?yearId=' + yearId +
      '&studentId=' + studentId;
    return this.http.post<StudentField>(System.apiURL.Student + 'SaveStudentFieldsData' + queryString, fields);
  }
}
